import { render, staticRenderFns } from "./businessManage.vue?vue&type=template&id=13cfcb6f&scoped=true"
import script from "./businessManage.vue?vue&type=script&lang=js"
export * from "./businessManage.vue?vue&type=script&lang=js"
import style0 from "./businessManage.vue?vue&type=style&index=0&id=13cfcb6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cfcb6f",
  null
  
)

export default component.exports